<template>
  <div>
    <h2>Ranking & Stats</h2>
    <b-row class="top-bar">
      <b-col md="3">
        <b-form-group horizontal label="Filter" class="mb-0">
          <b-input-group>
            <b-form-input v-model="filter" placeholder="Rechercher" />
            <b-input-group-append>
              <b-btn :disabled="!filter" @click="filter = ''">Effacer</b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="6" class="my-1">
        <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" />
      </b-col>
      <div>
      <button @click="filterSUS()" type="button" class="btn btn-primary">SUS</button>
      <button @click="getData()" type="button" class="btn btn-primary">Reset</button>
      </div>
    </b-row>
    <!-- <b-form-checkbox v-model="small">Small</b-form-checkbox>
    <b-form-checkbox v-model="dark">Dark</b-form-checkbox>
    <b-form-checkbox v-model="fixed">Fixed</b-form-checkbox> -->
    <b-table  hover
              :bordered="true"
              :outlined="true"
              :busy.sync="isBusy"
              :small="small"
              :dark="dark"
              :fixed="fixed"
              :foot-clone="true"
              :items="items"
              :filter="filter"
              @filtered="onFiltered"
              :fields="fields"
              :current-page="currentPage"
              :per-page="perPage">
      <div slot="table-busy" class="text-center text-danger my-2">
        <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
        <span class="sr-only">Loading...</span>
      </div>
      <template slot="kanban_card" slot-scope="row">
          <b-button class="mr-2">
        </b-button>
      </template>
      <template v-slot:cell(day_of_stock)="row">
        <p>{{row.item.day_of_stock}} J</p>
      </template>
      <template v-slot:cell(takt)="row">
        <p>{{row.item.takt_conso}} <small><em>({{row.item.takt_conso_stored}})</em></small></p>
      </template>
      <template v-slot:cell(cards)="row">
        <p>{{row.item.card_in_stock}} / {{row.item.card_total}} </p>
      </template>
    </b-table>
    <b-row>
      <b-col md="6" class="my-1">
        <b-pagination :total-rows="totalRows" :per-page="perPage" align="center" v-model="currentPage" />
      </b-col>
    </b-row>
  </div>
</template>
<script>

import server from '../../api/server.vue'
import moment from 'moment'
import { saveAs } from 'file-saver'

const items = [
  { isActive: true, loading: 'Loading' },
]

export default {
  name: 'RankingABC',
  data() {
    return {
        filter: null,
        sumOfScans: 0,
        sumOfScansCopy: 0,
        currentPage: 1,
        totalRows: 1,
        perPage: 50,
        small: false,
        fixed: false,
        dark: false,
        items: items,
        itemsSUS: [],
        itemsCopy: [],
        targetedReferences: '',
        isBusy: true,
        fields: [
          { key: 'id', sortable: true },
          { key: 'designation' },
          { key: 'supplier' },
          { key: 'days_of_stock', sortable: true },
          { key: 'takt', sortable: true },
          //{ key: 'takt_conso_stored', label: 'takt n-1', sortable: true },
          { key: 'cards', label:'Carte en stock / total', sortable: true },
          { key: 'card_in_stock_ratio', sortable: true },
          { key: 'kanban_stock', label: 'Stock Kanban', sortable: true },
          { key: 'nbr_scans', sortable: true },
          { key: 'pourcentage', sortable: true, label: 'Part dans les scans' },
        ],
      };
  },
  methods: {
    onFiltered (filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    filterSUS () {
      this.itemsCopy = this.items
      this.itemsSUS = []
      this.sumOfScansCopy = this.sumOfScans
      this.sumOfScans = 0
      this.items.forEach(item => {
        if (item.supplier === 'SUS') {
          this.items = this.itemsSUS
          this.sumOfScans += item.nbr_scans
          for (const item in this.items) {
            this.$set(this.items[item], 'pourcentage', ((this.items[item].nbr_scans / this.sumOfScans) * 100).toFixed(2) + '%')
          }
          this.itemsSUS.push(item)
        }
      })
    },
    getData () {
      server.getRankingABC().then( response =>
      {
        this.items = response.data.stats
        this.sumOfScans = response.data.sum_of_scans
        this.totalRows = this.items.length
        this.isBusy = false
        for (const item in this.items) {
          this.$set(this.items[item], 'pourcentage', ((this.items[item].nbr_scans / this.sumOfScans) * 100).toFixed(2) + '%')
        }
      })
    }
  },
  mounted: function () {
    this.getData()
  },
};
</script>
<style>
  .top-bar {
    align-items: center;
    justify-content: space-between;
  }
</style>


// WEBPACK FOOTER //
// src/components/andon/RankingABC.vue